import { SuccessResponseList } from './common'
import { User } from './user'

export enum CompanyStatus {
  ACTIVE = 'active',
  ARCHIVED = 'archived',
}

export interface RequestCreateCompany {
  name: string
  status: CompanyStatus
}

export interface RequestUpdateCompany {
  name: string | null
  status: CompanyStatus | null
}

export interface ResponseCompany {
  created_at: string
  created_by: string | null
  created_by_user?: User | null
  deleted_at: string | null
  deleted_by: string | null
  deleted_by_user?: User | null
  id: string
  name: string
  status: CompanyStatus
  total_projects: number
  updated_at: string
  updated_by: string | null
  updated_by_user?: User | null
}

export interface SuccessResponseListResponseCompany extends SuccessResponseList<ResponseCompany> {}
